import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import SFTextField from ".";
import useStyled from "../../hooks/useStyled";
import { SFSearchIcon, SFCloseIcon } from "../icons";
import InputAdornment from "@mui/material/InputAdornment";
import { SFIconButton } from "../buttons";

const { styled } = useStyled();

const StyledContainer = styled("div")(({ theme }) => ({
  display: "flex",
  marginRight: theme.spacing(1),
}));

const SFSearchFieldStyled = styled(SFTextField)(({ theme, variant }) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent !important",
  },
  "& .MuiInputBase-root": {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey450.main,
    color: theme.palette.grey200.main,
    borderRight: `1px solid ${theme.palette.grey550.main}`,
    borderBottom: `1px solid ${theme.palette.grey550.main}`,
    ...(variant === "filled" && {
      "&:before, &:after": {
        borderBottom: "none !important",
      },
    }),
  },
}));

const SFSearchField = ({
  onChange,
  placeholder,
  className,
  variant = "outlined",
  size = "medium",
  hasClearBtn = false,
}) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (value.length > 2 || value.length === 0) {
        onChange(value);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <SFSearchFieldStyled
      variant={variant}
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      className={className}
      InputProps={{
        startAdornment: (
          <StyledContainer>
            <SFSearchIcon />
          </StyledContainer>
        ),
        ...(hasClearBtn &&
          value.length > 0 && {
          endAdornment: (
            <InputAdornment position="end">
              <SFIconButton onClick={() => setValue("")} variant="transparent">
                <SFCloseIcon size="small" />
              </SFIconButton>
            </InputAdornment>
          ),
        }),
      }}
    />
  );
};

SFSearchField.propTypes = {
  // Called when there is a useful change in the search value
  onChange: PropTypes.func,
  // Placeholder when search value is empty
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  // Needed in order to use the useStyled hook
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default SFSearchField;
